import { useAppStore } from '../store/appStore';
import { useWorkspaceAssistantStore } from '../store/workspaceAssistantStore';
import { PANE_WIDE_WIDTH } from '../constants/paneLayout';

/**
 * The desktop right pane's width: the screen's override or the user's width, widened to the
 * conversation pane's while it shows the AI assistant (a wider user width is kept). The pane, the
 * content margin, forms and modals all read it, so they move together.
 */
export function useRightPaneWidth(override?: number): number {
  const stored = useAppStore(s => s.rightPaneWidth);
  const assistant = useWorkspaceAssistantStore(s => s.assistantShown);
  const width = override ?? stored;
  return assistant ? Math.max(width, PANE_WIDE_WIDTH) : width;
}
